__turbopack_context__.v({
  "className": "rethinksansfont_fa660a9e-module__k11t1q__className",
  "variable": "rethinksansfont_fa660a9e-module__k11t1q__variable",
});
